import { Box, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'

export const TomTableNoResultComponent = () => {
  const { t } = useTranslate()
  return (
    <Box
      sx={{
        position: 'fixed',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <Typography style={{ fontStyle: 'italic', color: '#637381' }} variant='body1'>
        {t('noResultFound', 'No result found')}
      </Typography>
    </Box>
  )
}
